const initialState = {};
export default function reducer(state = initialState /* , action */) {
  return state;
}

/*
CZK: {
  CZK: 1,
  EUR: 0.03846,
  USD: 0.04762
},
EUR: {
  CZK: 0.03861,
  EUR: 1,
  USD: 0.831
},
USD: {
  CZK: 0.046417,
  EUR: 1.204216,
  USD: 1
}
*/

export const selectors = {
  getCurrencies(state) {
    return state.currencies;
  },

  getAllCurrencyCodes(state) {
    return Object.keys(state.currencies);
  }
};
